var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.88889 11.8033V7.00453C5.88737 5.51696 6.44901 4.08191 7.46479 2.97795C8.48057 1.87398 9.87801 1.17988 11.3858 1.03038C12.8937 0.880884 14.4043 1.28666 15.6245 2.16893C16.8446 3.05119 17.6873 4.34702 17.9889 5.80483M3.44444 11.8033H20.5556C21.9056 11.8033 23 12.8776 23 14.2027V22.6006C23 23.9258 21.9056 25 20.5556 25H3.44444C2.09441 25 1 23.9258 1 22.6006V14.2027C1 12.8776 2.09441 11.8033 3.44444 11.8033Z",
    stroke: "currentColor",
    strokeWidth: "1.5px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.b3f57f66f96cf5ce3dbee08733c2bc8d.svg";
export { ForwardRef as ReactComponent };